export const ROLE_COLLECTIONNEUR = 'ROLE_COLLECTIONNEUR';
export const ROLE_TIREUR_SPORTIF = 'ROLE_TIREUR_SPORTIF';
export const ROLE_ANCIEN_TIREUR_SPORTIF = 'ROLE_ANCIEN_TIREUR_SPORTIF';
export const ROLE_CHASSEUR = 'ROLE_CHASSEUR';
export const ROLE_HERITIER = 'ROLE_HERITIER';
export const ROLE_CORRECTION_RATELIER_ARMES = 'ROLE_CORRECTION_RATELIER_ARMES';
export const ROLE_TIREUR_BALLTRAP = 'ROLE_TIREUR_BALLTRAP';
export const ROLE_ANCIEN_TIREUR_BALLTRAP = 'ROLE_ANCIEN_TIREUR_BALLTRAP';
export const ROLE_TIREUR_SKI = 'ROLE_TIREUR_SKI';
export const ROLE_ANCIEN_TIREUR_SKI = 'ROLE_ANCIEN_TIREUR_SKI';

export const DROITS_AUTORISATION_ACQUISION_DETENTION = [ROLE_TIREUR_SPORTIF];
export const DROITS_EDITER_CEAF = [
    ROLE_CHASSEUR,
    ROLE_HERITIER,
    ROLE_TIREUR_SPORTIF,
    ROLE_ANCIEN_TIREUR_SPORTIF,
    ROLE_TIREUR_BALLTRAP,
    ROLE_ANCIEN_TIREUR_BALLTRAP,
    ROLE_TIREUR_SKI,
    ROLE_ANCIEN_TIREUR_SKI,
];
export const DROITS_BOUTON_EDITER_CEAF = [
    ROLE_CHASSEUR,
    ROLE_TIREUR_SPORTIF,
    ROLE_ANCIEN_TIREUR_SPORTIF,
    ROLE_TIREUR_BALLTRAP,
    ROLE_ANCIEN_TIREUR_BALLTRAP,
    ROLE_TIREUR_SKI,
    ROLE_ANCIEN_TIREUR_SKI,
];

export const DROITS_SIGNALER_ARME_MANQUANTE = [
    ROLE_CHASSEUR,
    ROLE_HERITIER,
    ROLE_TIREUR_SPORTIF,
    ROLE_ANCIEN_TIREUR_SPORTIF,
    ROLE_TIREUR_BALLTRAP,
    ROLE_ANCIEN_TIREUR_BALLTRAP,
    ROLE_TIREUR_SKI,
    ROLE_ANCIEN_TIREUR_SKI,
];
export const DROITS_SIGNALER_ARME_ERREUR = [
    ROLE_CHASSEUR,
    ROLE_HERITIER,
    ROLE_TIREUR_SPORTIF,
    ROLE_ANCIEN_TIREUR_SPORTIF,
    ROLE_TIREUR_BALLTRAP,
    ROLE_ANCIEN_TIREUR_BALLTRAP,
    ROLE_TIREUR_SKI,
    ROLE_ANCIEN_TIREUR_SKI,
];

export const DROITS_HEADER_TITRE_DETENTION = [
    ROLE_CHASSEUR,
    ROLE_TIREUR_SPORTIF,
    ROLE_ANCIEN_TIREUR_SPORTIF,
    ROLE_TIREUR_BALLTRAP,
    ROLE_ANCIEN_TIREUR_BALLTRAP,
    ROLE_TIREUR_SKI,
    ROLE_ANCIEN_TIREUR_SKI,
];

export const DROITS_RATELIER_AJOUTER_UNE_ARME = [
    ROLE_CHASSEUR,
    ROLE_TIREUR_SPORTIF,
    ROLE_ANCIEN_TIREUR_SPORTIF,
    ROLE_TIREUR_BALLTRAP,
    ROLE_ANCIEN_TIREUR_BALLTRAP,
    ROLE_TIREUR_SKI,
    ROLE_ANCIEN_TIREUR_SKI,
];

export const DROITS_RATELIER_SIGNALER_UNE_ERREUR = [
    ROLE_CHASSEUR,
    ROLE_TIREUR_SPORTIF,
    ROLE_ANCIEN_TIREUR_SPORTIF,
    ROLE_TIREUR_BALLTRAP,
    ROLE_ANCIEN_TIREUR_BALLTRAP,
    ROLE_TIREUR_SKI,
    ROLE_ANCIEN_TIREUR_SKI,
];

export const DROITS_RATELIER_MESSAGE_SIGNALER_UNE_ERREUR = [ROLE_CHASSEUR, ROLE_TIREUR_SPORTIF];
